import { render, staticRenderFns } from "./BaseMaterialsImageUpload.vue?vue&type=template&id=035a5254&"
import script from "./BaseMaterialsImageUpload.vue?vue&type=script&lang=js&"
export * from "./BaseMaterialsImageUpload.vue?vue&type=script&lang=js&"
import style0 from "./BaseMaterialsImageUpload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports